// extracted by extract-css-chunks-webpack-plugin
module.exports = {"section":"HomeFiltersSection-e584fa2daa1ad07b"};